export { default as WebShopIcon } from "./components/WebShopIcon";
